import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

const ViewDetailsSkeleton = () => {
    return (
        <div className="container border p-4 mt-4">
            {/* Row 1 */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">EXIM</div>
                <div className="col-md-10"><Skeleton height={20} /></div>
            </div>

            {/* Row 2 */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Cargo Type</div>
                <div className="col-md-10"><Skeleton height={20} /></div>
            </div>

            {/* Row 3: Container Details */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Container Details</div>
                <div className="col-md-10">
                    <div className="border p-3">
                        <div className="row fw-semibold text-center mb-2">
                            <div className="col-md-4">Container Type</div>
                            <div className="col-md-4">No of Units</div>
                            <div className="col-md-4">Weight/Unit</div>
                        </div>
                        <div className="row">
                            <Skeleton height={20} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Row 4: Commodity */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Commodity</div>
                <div className="col-md-10">
                    <Skeleton height={20} />
                </div>
            </div>

            {/* Row 5: Incoterms */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Incoterms</div>
                <div className="col-md-10"><Skeleton height={20} /></div>
            </div>

            {/* Row 6: Customs Handling */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Customs Handling</div>
                <div className="col-md-10"><Skeleton height={20} /></div>
            </div>

            {/* Row 7: Insurance */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Insurance</div>
                <div className="col-md-10"><Skeleton height={20} /></div>
            </div>

            {/* Row 8: Special Instruction */}
            <div className="row mb-3">
                <div className="col-md-2 fw-bold">Special Instruction</div>
                <div className="col-md-10">
                    <Skeleton height={20} />
                </div>
            </div>
        </div>
    );
}

export default ViewDetailsSkeleton;